import { afterNextRender, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from '../../store/store.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: true,
})
export class CallbackComponent {
  constructor(
    private readonly store: StoreService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
    afterNextRender(async () => {
      const {
        auth: { authenticate, authorize },
      } = this.store.getActions();

      await authenticate(this.route.snapshot.queryParams);
      await authorize();
      await this.router.navigateByUrl('/home');
    });
  }
}
